<template>
	<pro-layout :show-help-icon="$store.getters.showHelpIcon" :menus="menus" :collapsed="collapsed" :mediaQuery="query"
		:isMobile="isMobile" :handleMediaQuery="handleMediaQuery" :handleCollapse="handleCollapse" :i18nRender="i18nRender"
		v-bind="settings">
		<!-- Ads begin
      广告代码 真实项目中请移除
      production remove this Ads
    -->
		<!-- <ads v-if="isProPreviewSite && !collapsed"/> -->
		<!-- Ads end -->

		<!-- layout content -->
		<!-- 2021.01.15 默认固定页头，去掉样式paddingTop: fixedHeader ? '64' : '0'  -->
		<a-layout-content :style="{ height: '100%', margin: '0 0 0px 0' }">
			<multi-tab v-if="settings.multiTab"></multi-tab>
			<transition name="page-transition">
			</transition>
		</a-layout-content>
		<!-- <template v-slot:menuHeaderRender>
			<div>
				<img src="~@/assets/logo.png" class="logo" alt="logo">
				<h1>{{ title }}</h1>
			</div>
		</template> -->
		<template v-slot:menuHeaderRender>
			<div>
				<div class="flex justify-start align-center">
					<!-- <img src="~@/assets/logos.png" class="logo_icon" alt="logo"> -->
					<img :src="pcLogo.configValue" class="logo_icon" alt="logo">
					
					<div class="user-info">
						<div class="user-nickname">{{ nickname }}</div>
						<div class="user-mobile">{{ mobile }}</div>
					</div>
				</div>
				<!-- <div v-if="roleType != 18" class="flex justify-start align-center account-tree-select-wrap" @click.stop>
					<a-tree-select
						v-model="selectData"
						size="small"
						class="flex-sub account-tree-select"
						dropdownClassName="account-tree-select-dropdown"
						:dropdown-style="{ maxHeight: '320px', overflow: 'auto', maxWidth: '220px' }"
						:dropdown-match-select-width="true"
						:tree-data="deptManageData"
						placeholder="请选择"
						search-placeholder="搜索用户"
						:replaceFields="replaceFields"
						tree-default-expand-all
						show-search
						tree-node-filter-prop="title"
						:filter-tree-node="filterAccountTreeNode"
						allow-clear
					/>
					<a-button @click.stop="handleChangeAccount" type="primary" class="switch change-btns margin-bottom-5" ghost>切换</a-button>
				</div> -->
			</div>

		</template>

		<!-- 菜单列表上方：账号切换（Dropdown + Tree，部门点标题可展开） -->
		<template v-slot:menuExtraRender>
			<div
				v-if="roleType != 18 && !collapsed"
				class="flex justify-start align-center account-tree-select-wrap menu-list-account-switch"
				:style="menuSwitchCssVars"
				@click.stop
			>
				<a-dropdown
					v-if="accountTreeReady"
					:key="'account-tree-' + accountTreeEpoch"
					:visible="accountDropdownVisible"
					:trigger="['click']"
					:getPopupContainer="getAccountPopupContainer"
					overlayClassName="menu-list-account-dropdown"
					@visibleChange="handleAccountDropdownVisible"
				>
					<div class="account-tree-trigger flex-sub" :title="accountSelectedLabel || '请选择'">
						<span class="account-tree-trigger-text">{{ accountSelectedLabel || '请选择' }}</span>
						<a-icon
							v-if="selectData"
							type="close-circle"
							theme="filled"
							class="account-tree-clear"
							@click.stop="clearAccountSelect"
						/>
					</div>
					<div
						slot="overlay"
						class="menu-list-account-panel"
						:style="accountDropdownPanelStyle"
						@click.stop
					>
						<a-input
							v-model="accountSearchKeyword"
							size="small"
							allow-clear
							placeholder="搜索用户"
							class="account-tree-search"
							@click.stop
						/>
						<div class="menu-list-account-tree-wrap">
							<a-tree
								v-if="filteredAccountTreeData.length"
								blockNode
								:tree-data="filteredAccountTreeData"
								:replaceFields="accountTreeReplaceFields"
								:expandedKeys="accountTreeExpandedKeys"
								:selectedKeys="accountSelectedKeys"
								:autoExpandParent="accountAutoExpandParent"
								@expand="onAccountTreeExpand"
								@select="onAccountTreeSelect"
							/>
							<div v-else class="menu-list-account-empty">暂无数据</div>
						</div>
					</div>
				</a-dropdown>
				<a-button
					@click.stop="handleChangeAccount"
					type="primary"
					class="switch change-btns menu-list-switch-btn"
					ghost
				>切换</a-button>
			</div>
		</template>

		<!-- 右侧设置按钮 -->
		<!-- <setting-drawer v-if="isProPreviewSite" :settings="settings" @change="handleSettingChange" /> -->

		<template v-slot:rightContentRender>
			<!-- <right-content :top-menu="settings.layout === 'topmenu'" :is-mobile="isMobile" :theme="settings.theme" /> -->
		</template>
		<!-- <template v-slot:footerRender v-if="!hideFooter">
			<global-footer />
		</template> -->
		<div>
			<!-- 仅一层 keep-alive：有标签缓存名单时按组件名 include；不设 max，与多 tab 无限缓存一致 -->
			<keep-alive v-bind="keepAliveBind">
				<router-view :key="key" />
			</keep-alive>
		</div>
	</pro-layout>
</template>

<script>
	import MultiTab from '@/components/MultiTab'

	import themeColor from '@/components/SettingDrawer/themeColor'
	import SettingDrawer from '@/components/SettingDrawer'
	import {
		i18nRender
	} from '@/locales'
	import {
		mapState
	} from 'vuex'
	import {
		CONTENT_WIDTH_TYPE,
		SIDE_COLLAPSED,
		TOGGLE_MOBILE_TYPE,
		TOGGLE_CONTENT_WIDTH,
		TOGGLE_FIXED_HEADER,
		TOGGLE_FIXED_SIDEBAR,
		TOGGLE_LAYOUT,
		TOGGLE_NAV_THEME,
		TOGGLE_WEAK,
		TOGGLE_COLOR,
		TOGGLE_MULTI_TAB,
		TABLE_SIZE,
		TABLE_BORDERED,
		HIDE_FOOTER
	} from '@/store/mutation-types'

	import defaultSettings from '@/config/defaultSettings'
	import RightContent from '@/components/GlobalHeader/RightContent'
	// import GlobalFooter from '@/components/GlobalFooter'
	import Ads from '@/components/Other/CarbonAds'
	import {
		baseMixin
	} from '@/store/app-mixin'

	import bus from '@/utils/bus'
	import { reloadAfterSwitchAccount } from '@/utils/switchAccount'
	import { hasYesterdayLog } from '@/api/customer/LogReport.js'
	import Modal from 'ant-design-vue/es/modal'

	import {
		deptTree,
		deptUserCascadeTreeForSwitch,
		changeAccount,
		configConfiglist,
	} from '@/api/public.js';
	import { getRouteTabCacheKey } from '@/utils/routeTab'
	
	import storage from 'store'

	export default {
		name: 'BasicLayout',
		components: {
			SettingDrawer,
			RightContent,
			// GlobalFooter,
			Ads,
			MultiTab
		},
		mixins: [baseMixin],
		data() {
			return {
				// preview.pro.antdv.com only use.是否展示设置页面样式按钮；先写死 true;后续可根据 process.env.VUE_APP_PREVIEW === 'true', 进行控制
				isProPreviewSite: true, //process.env.VUE_APP_PREVIEW === 'true',
				// end
				// base
				menus: [],
				// 侧栏展开状态
				collapsed: false,
				title: defaultSettings.title,
				settings: {
					// 布局类型
					layout: defaultSettings.layout, // 'sidemenu', 'topmenu'
					// CONTENT_WIDTH_TYPE
					contentWidth: defaultSettings.layout === 'sidemenu' ? CONTENT_WIDTH_TYPE.Fluid : defaultSettings.contentWidth,
					// 主题 'dark' | 'light'

					// 主色调
					primaryColor: defaultSettings.primaryColor,
					fixedHeader: defaultSettings.fixedHeader,
					fixSiderbar: defaultSettings.fixSiderbar,
					multiTab: defaultSettings.multiTab,
					colorWeak: defaultSettings.colorWeak,

					hideHintAlert: true,
					hideCopyButton: false,
					tableSize: defaultSettings.tableSize,
					tableBordered: defaultSettings.tableBordered,
					hideFooter: defaultSettings.hideFooter
				},
				// 媒体查询
				query: {},
				selectData: undefined,
				deptManageData: [],
				accountTreeExpandedKeys: [],
				accountSelectedKeys: [],
				accountTreeReady: false,
				accountTreeEpoch: 0,
				accountDropdownWidth: 150,
				accountDropdownVisible: false,
				accountSearchKeyword: '',
				accountAutoExpandParent: false,
				accountTreeReplaceFields: { children: 'children', title: 'name', key: 'nodeKey' },
				replaceFields: { children: 'children', title: 'name', key: 'nodeKey', value: 'nodeValue' },
				roleType:'',
				pcLogo:null,
				yesterdayLogResolved: false,
				_yesterdayLogChecking: false,
				_yesterdayLogModalShowing: false,
			}
		},
		computed: {
			...mapState({
				// 动态主路由
				mainMenu: state => state.permission.menus,
				nickname: state => state.user.name || state.user.username || '管理员',
				userInfo: state => state.user.info,
				mobile: state => state.user.mobile,
			}),
			cachedViews() {
				return this.$store.state.tagsView.cachedViews
			},
			keepAliveBind() {
				const include = this.cachedViews
				// 不设 max，按打开的 tab 无限缓存，避免列表页被详情挤出后返回时重建刷新
				if (Array.isArray(include) && include.length) {
					return {
						include
					}
				}
				return {}
			},
			key() {
				return getRouteTabCacheKey(this.$route, this.$store.state.multiTab.pages)
			},
			/** 下拉面板宽度与主题色 */
			accountDropdownPanelStyle() {
				const w = this.accountDropdownWidth || 150
				return {
					width: `${w}px`,
					minWidth: `${w}px`,
					...this.menuSwitchCssVars,
				}
			},
			/** 切换区 / 下拉主题色变量（随 primaryColor 变化） */
			menuSwitchCssVars() {
				const color = this.primaryColor || '#1890ff'
				return {
					'--menu-switch-primary': color,
					'--menu-switch-primary-bg': this.hexToRgba(color, 0.12),
					'--menu-switch-primary-bg-hover': this.hexToRgba(color, 0.08),
				}
			},
			accountSelectedLabel() {
				if (!this.selectData) return ''
				const node = this.findAccountNodeByValue(this.deptManageData, this.selectData)
				return node ? (node.name || '') : ''
			},
			filteredAccountTreeData() {
				const keyword = (this.accountSearchKeyword || '').trim().toLowerCase()
				if (!keyword) return this.deptManageData
				return this.filterAccountTreeByKeyword(this.deptManageData, keyword)
			},
		},
		created() {
			this.updateSideMenus()
			// 处理侧栏展开状态
			this.$watch('collapsed', () => {
				this.$store.commit(SIDE_COLLAPSED, this.collapsed)
			})
			bus.$on('changeAccount', () => {
				console.log('触发了')
				this.getUserList();
			})
			bus.$on('refreshMenuBadgeCount', this.fetchCustomerMenuBadgeCounts)
		},
		beforeDestroy() {
			bus.$off('refreshMenuBadgeCount', this.fetchCustomerMenuBadgeCounts)
		},
		mounted() {
			console.log(this.$store.state,'$route-存储数据');
			if (this.isProPreviewSite) {
				this.settings.layout = this.layout
				this.settings.contentWidth = this.contentWidth

				this.settings.primaryColor = this.primaryColor
				this.settings.fixedHeader = this.fixedHeader
				this.settings.fixSiderbar = this.fixedSidebar
				this.settings.multiTab = this.multiTab
				this.settings.colorWeak = this.colorWeak
				this.settings.tableSize = this.tableSize
				this.settings.tableBordered = this.tableBordered
				this.settings.hideFooter = this.hideFooter
			}
			this.collapsed = this.sideCollapsed
			const userAgent = navigator.userAgent
			if (userAgent.indexOf('Edge') > -1) {
				this.$nextTick(() => {
					this.collapsed = !this.collapsed
					setTimeout(() => {
						this.collapsed = !this.collapsed
					}, 16)
				})
			}

			// first update color
			// TIPS: THEME COLOR HANDLER!! PLEASE CHECK THAT!!
			if (process.env.NODE_ENV !== 'production' || process.env.VUE_APP_PREVIEW === 'true') {
				themeColor.changeColor(this.settings.primaryColor)
			}
			this.getUserList();
			this.fetchCustomerMenuBadgeCounts();
			
			const accountList = storage.get('ACCOUNT_LIST') || []
			this.roleType = (Array.isArray(accountList) && accountList[0] && accountList[0].id != null)
				? accountList[0].id
				: '';
			
			this.getPcLogo();
			this.checkYesterdayLog();
		},
		watch: {
			mainMenu: {
				deep: true,
				handler() {
					this.updateSideMenus()
				}
			},
			selectData(newVal) {
				if (!newVal) {
					this.handleTreeSelectClear()
				} else {
					this.syncAccountSelectedKeys()
				}
			},
			accountSearchKeyword(val) {
				const keyword = (val || '').trim()
				if (!keyword) {
					this.accountAutoExpandParent = false
					return
				}
				this.accountAutoExpandParent = true
				this.accountTreeExpandedKeys = this.collectExpandableKeys(this.filteredAccountTreeData)
			},
			'$route'(to) {
				// 未提交昨日日志时，离开日志列表进入其他菜单仍提示
				if (this.yesterdayLogResolved || this.isLogReportRoute(to)) {
					return
				}
				this.$nextTick(() => {
					this.checkYesterdayLog()
				})
			}
		},
		methods: {
			fetchCustomerMenuBadgeCounts() {
				return this.$store.dispatch('menu/fetchCustomerMenuBadgeCounts')
			},
			isLogReportRoute(route = this.$route) {
				if (!route) {
					return false
				}
				const path = String(route.path || '')
				const name = String(route.name || '')
				const matched = route.matched || []
				if (/LogReport/i.test(path) || /LogReport/i.test(name)) {
					return true
				}
				return matched.some(item => {
					const comp = item.components && item.components.default
					const compName = (comp && (comp.name || (comp.options && comp.options.name))) || ''
					const file = String((item.meta && item.meta.component) || item.path || '')
					return /LogReport/i.test(compName) || /LogReport/i.test(file)
				})
			},
			findLogReportPath() {
				const menuList = (this.$store.state.menu && this.$store.state.menu.menuList) || []
				let targetName = ''
				const walkRaw = (list) => {
					for (const item of list || []) {
						if (/LogReport/i.test(String(item.component || ''))) {
							targetName = item.name || ''
							return true
						}
						if (item.children && walkRaw(item.children)) {
							return true
						}
					}
					return false
				}
				walkRaw(menuList)

				const walkMenus = (list) => {
					for (const item of list || []) {
						const path = String(item.path || '')
						const name = String(item.name || '')
						if ((targetName && name === targetName) || /LogReport/i.test(path) || /LogReport/i.test(name)) {
							if (path && path !== '/') {
								return path.startsWith('/') ? path : `/${path}`
							}
						}
						const child = walkMenus(item.children)
						if (child) {
							return child
						}
					}
					return ''
				}
				const fromMenus = walkMenus(this.mainMenu)
				if (fromMenus) {
					return fromMenus
				}

				const root = this.$store.state.permission && this.$store.state.permission.routers
				const children = (root && root.children) || []
				const hit = children.find(r =>
					(targetName && r.name === targetName) ||
					/LogReport/i.test(String(r.path || '')) ||
					/LogReport/i.test(String(r.name || ''))
				)
				if (hit && hit.path) {
					return hit.path.startsWith('/') ? hit.path : `/${hit.path}`
				}
				return '/customer/LogReport'
			},
			goToLogReportList() {
				const target = this.findLogReportPath()
				if (this.isLogReportRoute(this.$route)) {
					return
				}
				this.$router.push(target).catch(() => {})
			},
			/** 仅业务员/主管/区长需要检查并补录昨日日志 */
			isLogRequiredRole(userInfo = {}) {
				const required = ['业务员', '主管', '区长']
				const names = []
				const list = userInfo.roleList
				if (Array.isArray(list) && list.length) {
					list.forEach(item => {
						const name = typeof item === 'string' ? item : (item && item.roleName)
						if (name) {
							names.push(String(name).trim())
						}
					})
				}
				if (userInfo.roleName) {
					names.push(String(userInfo.roleName).trim())
				}
				if (userInfo.roleNames) {
					String(userInfo.roleNames).split(/[,，]/).forEach(n => {
						const name = String(n || '').trim()
						if (name) {
							names.push(name)
						}
					})
				}
				return names.some(name => required.includes(name))
			},
			/** 进入系统后检查昨日日志 */
			async checkYesterdayLog() {
				if (this.yesterdayLogResolved || this._yesterdayLogChecking || this._yesterdayLogModalShowing) {
					return
				}
				if (this.isLogReportRoute()) {
					return
				}
				this._yesterdayLogChecking = true
				try {
					let userInfo = this.$store.state.user.info || {}
					const roleList = userInfo.roleList
					if (!Array.isArray(roleList) || !roleList.length) {
						const res = await this.$store.dispatch('GetInfo')
						userInfo = (res && res.data) || this.$store.state.user.info || {}
					}
					if (!this.isLogRequiredRole(userInfo)) {
						this.yesterdayLogResolved = true
						return
					}
					const res = await hasYesterdayLog()
					if (res.code != '20001') {
						return
					}
					const written = res.data === true || res.data === 'true' || res.data === 1
					if (written) {
						this.yesterdayLogResolved = true
						return
					}
					this.showYesterdayLogConfirm()
				} catch (e) {
					// 角色/日志接口失败时不打断进入系统
				} finally {
					this._yesterdayLogChecking = false
				}
			},
			showYesterdayLogConfirm() {
				if (this._yesterdayLogModalShowing || this.yesterdayLogResolved || this.isLogReportRoute()) {
					return
				}
				this._yesterdayLogModalShowing = true
				Modal.confirm({
					title: '提示',
					content: '您昨日尚未提交日志，请及时补录',
					okText: '去处理',
					cancelText: '暂不处理',
					maskClosable: false,
					keyboard: false,
					closable: false,
					centered: true,
					zIndex: 2000,
					onOk: () => {
						this._yesterdayLogModalShowing = false
						this.goToLogReportList()
					},
					onCancel: () => {
						this._yesterdayLogModalShowing = false
						this.goToLogReportList()
					}
				})
			},
			updateSideMenus() {
				const routes = this.mainMenu.find(item => item.path === '/')
				this.menus = (routes && routes.children) || []
			},
			i18nRender,
			handleMediaQuery(val) {
				this.query = val
				if (this.isMobile && !val['screen-xs']) {
					this.$store.commit(TOGGLE_MOBILE_TYPE, false)
					return
				}
				if (!this.isMobile && val['screen-xs']) {
					this.$store.commit(TOGGLE_MOBILE_TYPE, true)
					this.collapsed = true
					this.settings.contentWidth = CONTENT_WIDTH_TYPE.Fluid
					// this.settings.fixSiderbar = false
				}
			},
			// 获取当前登陆人员组织架构
			async getUserList() {
				await deptUserCascadeTreeForSwitch().then(res => {
					console.log('公司员工', res);
					if (res.code == '20001') {
						const rootNode = this.formatCascadeNodeName(res.data);
						this.deptManageData = this.cleanEmptyChildren([rootNode]);
						this.selectData = this.getMobileByUserId(this.deptManageData, localStorage.getItem('userId'));
						this.syncAccountSelectedKeys()
						this.accountTreeExpandedKeys = this.collectExpandableKeys(this.deptManageData)
						this.accountTreeEpoch += 1
						this.accountTreeReady = true
					}
				})
			},
			getMobileByUserId(tree, userId) {
				const path = this.getMobileTopToDown(tree, userId);
				return path.length ? path[path.length - 1] : undefined;
			},
			findAccountNodeByValue(nodes, value) {
				const target = value == null ? '' : String(value)
				for (const node of (nodes || [])) {
					const nodeVal = node.nodeValue != null ? node.nodeValue : node.mobile
					if (String(nodeVal) === target) return node
					if (node.children && node.children.length) {
						const found = this.findAccountNodeByValue(node.children, target)
						if (found) return found
					}
				}
				return null
			},
			syncAccountSelectedKeys() {
				const node = this.findAccountNodeByValue(this.deptManageData, this.selectData)
				this.accountSelectedKeys = node && node.nodeKey != null ? [String(node.nodeKey)] : []
			},
			filterAccountTreeByKeyword(nodes, keyword) {
				const result = []
				;(nodes || []).forEach(node => {
					const isUser = node.nodeType === 'USER'
					const name = String(node.name || '').toLowerCase()
					const children = this.filterAccountTreeByKeyword(node.children || [], keyword)
					// 人员/部门均只按姓名匹配（部门不用 __org_${id} 假手机号）
					const selfMatch = name.includes(keyword)
					if (selfMatch || children.length) {
						let nextChildren = []
						if (children.length) {
							nextChildren = children
						} else if (selfMatch && !isUser) {
							// 部门名称命中且无子级过滤结果时，保留原有子节点便于继续选择
							nextChildren = node.children || []
						}
						result.push({
							...node,
							children: nextChildren,
						})
					}
				})
				return result
			},
			hexToRgba(hex, alpha = 1) {
				const raw = String(hex || '').replace('#', '').trim()
				if (!raw) return `rgba(24, 144, 255, ${alpha})`
				const full = raw.length === 3
					? raw.split('').map(c => c + c).join('')
					: raw
				if (full.length !== 6) return `rgba(24, 144, 255, ${alpha})`
				const r = parseInt(full.slice(0, 2), 16)
				const g = parseInt(full.slice(2, 4), 16)
				const b = parseInt(full.slice(4, 6), 16)
				if ([r, g, b].some(n => Number.isNaN(n))) return `rgba(24, 144, 255, ${alpha})`
				return `rgba(${r}, ${g}, ${b}, ${alpha})`
			},
			collectExpandableKeys(nodes, keys = []) {
				;(nodes || []).forEach(node => {
					if (node && Array.isArray(node.children) && node.children.length) {
						keys.push(String(node.nodeKey != null ? node.nodeKey : node.id))
						this.collectExpandableKeys(node.children, keys)
					}
				})
				return keys
			},
			getAccountPopupContainer(triggerNode) {
				return (triggerNode && triggerNode.closest('.menu-list-account-switch')) || document.body
			},
			updateAccountDropdownWidth() {
				const wrap = this.$el && this.$el.querySelector('.menu-list-account-switch')
				if (!wrap) {
					this.accountDropdownWidth = 150
					return
				}
				const style = window.getComputedStyle(wrap)
				const pl = parseFloat(style.paddingLeft) || 0
				const pr = parseFloat(style.paddingRight) || 0
				const total = wrap.getBoundingClientRect().width
				this.accountDropdownWidth = Math.max(120, Math.floor(total - pl - pr))
			},
			onAccountTreeExpand(keys) {
				this.accountAutoExpandParent = false
				this.accountTreeExpandedKeys = Array.isArray(keys) ? keys.map(k => String(k)) : []
			},
			/** 人员：选中；部门：点标题展开/收起 */
			onAccountTreeSelect(selectedKeys, info) {
				const node = info && info.node
				if (!node) return
				const dataRef = node.dataRef || (node.$props && node.$props.dataRef) || {}
				const isUser = dataRef.nodeType === 'USER'
				const eventKey = String(
					node.eventKey != null
						? node.eventKey
						: (dataRef.nodeKey != null ? dataRef.nodeKey : ((selectedKeys && selectedKeys[0]) || ''))
				)
				if (isUser) {
					// status !== 1 的人员不可切换
					if (Number(dataRef.status) !== 1) {
						this.syncAccountSelectedKeys()
						return
					}
					this.selectData = dataRef.nodeValue != null ? dataRef.nodeValue : dataRef.mobile
					this.accountSelectedKeys = eventKey ? [eventKey] : []
					this.accountDropdownVisible = false
					return
				}
				if (eventKey) {
					const cur = (this.accountTreeExpandedKeys || []).map(k => String(k))
					const idx = cur.indexOf(eventKey)
					if (idx >= 0) cur.splice(idx, 1)
					else cur.push(eventKey)
					this.accountTreeExpandedKeys = cur
				}
				this.syncAccountSelectedKeys()
			},
			handleAccountDropdownVisible(open) {
				this.accountDropdownVisible = open
				if (!open) {
					this.accountSearchKeyword = ''
					return
				}
				this.updateAccountDropdownWidth()
				this.$nextTick(() => this.updateAccountDropdownWidth())
			},
			clearAccountSelect() {
				this.selectData = undefined
			},
			// 树节点：人员 status=1 可选；非 1 禁用；部门可点标题展开
			formatCascadeNodeName(node) {
				if (!node) return node;
				const isUser = node.nodeType === 'USER';
				const nodeKey = String(node.id != null ? node.id : '')
				const userEnabled = !isUser || Number(node.status) === 1
				const nextNode = {
					...node,
					nodeKey,
					nodeValue: isUser ? node.mobile : `__org_${nodeKey}`,
					mobile: isUser ? node.mobile : (node.mobile || `__org_${nodeKey}`),
					disabled: isUser ? !userEnabled : false,
					selectable: isUser ? userEnabled : true,
					isLeaf: isUser || !(Array.isArray(node.children) && node.children.length),
				};
				if (Array.isArray(node.children) && node.children.length > 0) {
					nextNode.children = node.children.map(child => this.formatCascadeNodeName(child));
				}
				return nextNode;
			},
			// 切换账号
			async handleChangeAccount() {
				if (!this.selectData) {
					return this.$message.error('请选择要切换的账号');
				}
				const accountNo = this.selectData;
				try {
					// 1. 切换账号（只传账号）
					await this.$store.dispatch('SwitchAccount', accountNo)
					// 2. 重新获取新账号信息
					await this.$store.dispatch('GetInfo')
					const loginAccount = String((JSON.parse(localStorage.getItem('ACCOUNT_LIST') || '[]')[0] || {}).mobile || '')
					const switchAccount = String(this.$store.state.user.mobile || '')
					let isEditPage = true // 默认可编辑
					if (loginAccount && switchAccount && loginAccount !== switchAccount) {
						// 非原账号：仅原账号为 admin 时可编辑
						isEditPage = loginAccount === 'admin'
					}
					localStorage.setItem('CLUEEDIT', String(isEditPage))
					reloadAfterSwitchAccount()
				} catch (e) {
					console.log('切换失败', e)
				}
			},
			async handleTreeSelectClear() {
				let accountList = JSON.parse(localStorage.getItem('ACCOUNT_LIST'))
				if (accountList[0].mobile == this.mobile) {
					this.selectData = this.getMobileByUserId(this.deptManageData, localStorage.getItem('userId'));
					return false
				}
				try {
					// 1. 切换账号（只传账号）
					await this.$store.dispatch('SwitchAccount', accountList[0].mobile)
					// 2. 重新获取新账号信息
					await this.$store.dispatch('GetInfo')
					localStorage.setItem('CLUEEDIT', 'true')
					reloadAfterSwitchAccount()
				} catch (e) {
					console.log('切换失败', e)
				}
			},
			handleCollapse(val) {
				this.collapsed = val
			},
			// 获取logo
			getPcLogo(){
				configConfiglist({configName:'PC_LOGO'}).then(res =>{
					console.log('公司PC_LOGO',res);
					if(res.code=='20001'){
						this.pcLogo = res.data[0];
					}
				})
			},
			handleSettingChange({
				type,
				value
			}) {
				type && (this.settings[type] = value)
				switch (type) {
					case 'primaryColor':
						this.$store.commit(TOGGLE_COLOR, value);
						themeColor.changeColor(value);
						break;
					case 'contentWidth':
						this.settings[type] = value
						this.$store.commit(TOGGLE_CONTENT_WIDTH, value)
						break;
					case 'layout':
						this.$store.commit(TOGGLE_LAYOUT, value)
						if (value === 'sidemenu') {
							this.settings.contentWidth = CONTENT_WIDTH_TYPE.Fluid
							this.$store.commit(TOGGLE_CONTENT_WIDTH, CONTENT_WIDTH_TYPE.Fluid)
						} else {
							this.settings.fixSiderbar = false
							this.$store.commit(TOGGLE_FIXED_SIDEBAR, false)
							this.settings.contentWidth = CONTENT_WIDTH_TYPE.Fixed
							this.$store.commit(TOGGLE_CONTENT_WIDTH, CONTENT_WIDTH_TYPE.Fixed)
						}
						break;
					case 'fixSiderbar':
						this.$store.commit(TOGGLE_FIXED_SIDEBAR, value)
						break
					case 'fixedHeader':
						this.$store.commit(TOGGLE_FIXED_HEADER, value)
						break
					case 'multiTab':
						this.$store.commit(TOGGLE_MULTI_TAB, value)
						break
					case 'colorWeak':
						this.$store.commit(TOGGLE_WEAK, value)
						break
					case 'tableSize':
						this.$store.commit(TABLE_SIZE, value)
						break
					case 'tableBordered':
						this.$store.commit(TABLE_BORDERED, value)
						break
					case 'hideFooter':
						this.$store.commit(HIDE_FOOTER, value)
						break
				}
			}
		}
	}
</script>

<style lang="less" scoped>
	@import "./BasicLayout.less";
	
	.margin-bottom-5 {
		margin: 5px 0;
	}

	.ant-pro-sider-menu-sider.fix-sider-bar {
		display: flex !important;
		flex-direction: column;
		height: 100vh;
	}

	.ant-pro-sider-menu-sider.fix-sider-bar .ant-menu-root {
		flex: 1;
		min-height: 0;
		height: auto !important;
		overflow-y: auto;
	}

	.ant-pro-sider-menu-logo {
		flex-shrink: 0;
		height: 104px;
		padding: 7px 0 7px 24px;
	}

	.menu-list-account-switch {
		flex-shrink: 0;
		padding: 10px 15px;
		box-sizing: border-box;
		position: relative;
		overflow: visible;
	}

	.logo_icon {
		width: 72px !important;
		height: 38px !important;
		margin-right: 10px;
	}

	.user-nickname,
	.user-mobile {
		color: #fff;
		line-height: 15px;
	}
	
	
	// 调整菜单栏高度 开始
	::v-deep .ant-menu-sub.ant-menu-inline > .ant-menu-item {
		height: 30px !important;
		line-height: 30px !important;
		white-space: nowrap !important;
		overflow: visible !important;
		text-overflow: clip !important;
		/* 默认约 48px，收窄侧栏后减小缩进，避免长菜单名被裁切 */
		padding-left: 35px !important;
	}

	::v-deep .ant-menu-sub.ant-menu-inline > .ant-menu-submenu > .ant-menu-submenu-title {
		padding-left: 35px !important;
	}

	/* 三级菜单适当小于二级缩进增量 */
	::v-deep .ant-menu-sub .ant-menu-sub.ant-menu-inline > .ant-menu-item,
	::v-deep .ant-menu-sub .ant-menu-sub.ant-menu-inline > .ant-menu-submenu > .ant-menu-submenu-title {
		padding-left: 45px !important;
	}
	
	::v-deep .ant-menu-submenu > .ant-menu-submenu-title, .ant-menu-inline > .ant-menu-submenu > .ant-menu-submenu-title {
		height: 30px !important;
		line-height: 30px !important;
		white-space: nowrap !important;
		overflow: visible !important;
		text-overflow: clip !important;
	}

	::v-deep .ant-menu-item,
	::v-deep .ant-menu-submenu-title {
		height: 30px !important;
		white-space: nowrap !important;
		overflow: visible !important;
		text-overflow: clip !important;
	}

	::v-deep .ant-menu-item > a,
	::v-deep .ant-menu-submenu-title > span {
		overflow: visible !important;
		text-overflow: clip !important;
		white-space: nowrap !important;
	}

	::v-deep .ant-menu-root {
		overflow-x: auto;
	}
	
	::v-deep .ant-menu-inline .ant-menu-item:not(:last-child) {
		margin-bottom:0;
	}
	
	// 调整菜单栏高度 结束
	
	// 切换按钮：与账号下拉框高度一致
	.change-btns.ant-btn {
		font-size: 10px;
		margin-left: 6px;
		height: 22px;
		line-height: 20px;
		padding: 0 8px;
		min-width: auto;
	}

	.ant-btn {
		padding: 0 10px;
	}
	

	.ant-btn-background-ghost.ant-btn-primary {
		border: 1px solid #fff !important;
		color: #fff !important;
		text-align: center;
	}

	::v-deep .ant-menu {
		font-size: 12px !important;
	}

	::v-deep .ant-pro-sider-menu-logo {
		min-height: 41px !important;
		padding: 0 12px !important;
	}

	// 账号切换触发框
	.account-tree-select-wrap {
		margin: 0;
	}

	.menu-list-account-switch.account-tree-select-wrap {
		padding: 10px 15px 0px;
	}

	.account-tree-trigger {
		position: relative;
		display: flex;
		align-items: center;
		min-width: 0;
		height: 22px;
		padding: 0 22px 0 8px;
		box-sizing: border-box;
		font-size: 10px;
		line-height: 20px;
		background-color: #fff;
		border: 1px solid #d9d9d9;
		border-radius: 2px;
		color: rgba(0, 0, 0, 0.65);
		cursor: pointer;
		user-select: none;
	}

	.account-tree-trigger:hover {
		border-color: #bfbfbf;
	}

	.account-tree-trigger-text {
		flex: 1;
		min-width: 0;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
	}

	.account-tree-clear {
		position: absolute;
		right: 4px;
		top: 50%;
		transform: translateY(-50%);
		font-size: 12px;
		color: rgba(0, 0, 0, 0.25);
		opacity: 0;
		pointer-events: none;
		transition: opacity 0.2s;
	}

	.account-tree-trigger:hover .account-tree-clear {
		opacity: 1;
		pointer-events: auto;
	}

	.account-tree-clear:hover {
		color: rgba(0, 0, 0, 0.45);
	}

	/* 菜单列表上的账号切换：主题色切换按钮 */
	.menu-list-account-switch {
		.menu-list-switch-btn.ant-btn-background-ghost.ant-btn-primary {
			color: var(--menu-switch-primary, #1890ff) !important;
			border: 1px solid var(--menu-switch-primary, #1890ff) !important;
			background: transparent !important;
		}

		.menu-list-switch-btn.ant-btn-background-ghost.ant-btn-primary:hover,
		.menu-list-switch-btn.ant-btn-background-ghost.ant-btn-primary:focus {
			color: var(--menu-switch-primary, #1890ff) !important;
			border-color: var(--menu-switch-primary, #1890ff) !important;
			opacity: 0.85;
		}
	}
</style>

<style lang="less">
	/* 左侧菜单滚动条（客户管理展开后滚动容器为 .ant-menu-root） */
	.ant-pro-sider-menu-sider.fix-sider-bar .ant-menu-root {
		scrollbar-width: thin;
	}

	.ant-pro-sider-menu-sider.fix-sider-bar .ant-menu-root::-webkit-scrollbar {
		width: 4px !important;
	}

	.ant-pro-sider-menu-sider.fix-sider-bar .ant-menu-root::-webkit-scrollbar-track {
		background: transparent;
	}

	.ant-pro-sider-menu-sider.fix-sider-bar .ant-menu-root::-webkit-scrollbar-thumb {
		background: rgba(0, 0, 0, 0.2);
		border-radius: 2px;
	}

	/* 账号切换下拉（Dropdown + Tree） */
	.menu-list-account-dropdown {
		z-index: 1050;
	}

	.menu-list-account-dropdown .menu-list-account-panel {
		background: #fff;
		border: 1px solid #d9d9d9;
		border-radius: 2px;
		box-shadow: 0 2px 8px rgba(0, 0, 0, 0.12);
		box-sizing: border-box;
		padding: 6px 0 4px;
	}

	.menu-list-account-dropdown .account-tree-search {
		display: block;
		width: calc(100% - 16px);
		margin: 0 8px 6px;
	}

	.menu-list-account-dropdown .account-tree-search.ant-input-affix-wrapper,
	.menu-list-account-dropdown .account-tree-search.ant-input {
		height: 28px;
		font-size: 12px;
	}

	.menu-list-account-dropdown .menu-list-account-tree-wrap {
		max-height: 280px;
		overflow: auto;
		padding: 0 4px 4px;
		scrollbar-width: thin;
		scrollbar-color: rgba(0, 0, 0, 0.15) transparent;
	}

	.menu-list-account-dropdown .menu-list-account-tree-wrap::-webkit-scrollbar {
		width: 4px !important;
		height: 4px !important;
	}

	.menu-list-account-dropdown .menu-list-account-tree-wrap::-webkit-scrollbar-track {
		background: transparent;
	}

	.menu-list-account-dropdown .menu-list-account-tree-wrap::-webkit-scrollbar-thumb {
		background: rgba(0, 0, 0, 0.15);
		border-radius: 2px;
	}

	.menu-list-account-dropdown .menu-list-account-empty {
		padding: 12px 8px;
		font-size: 12px;
		color: rgba(0, 0, 0, 0.45);
		text-align: center;
	}

	.menu-list-account-dropdown .ant-tree {
		font-size: 12px;
	}

	.menu-list-account-dropdown .ant-tree li {
		margin: 0 !important;
		padding: 0 !important;
	}

	.menu-list-account-dropdown .ant-tree li .ant-tree-node-content-wrapper {
		height: 24px;
		line-height: 24px;
		padding: 0 4px;
		font-size: 12px;
		cursor: pointer;
	}

	.menu-list-account-dropdown .ant-tree li .ant-tree-node-content-wrapper:hover {
		background-color: var(--menu-switch-primary-bg-hover, rgba(24, 144, 255, 0.08)) !important;
	}

	.menu-list-account-dropdown .ant-tree li .ant-tree-node-content-wrapper.ant-tree-node-selected {
		background-color: var(--menu-switch-primary-bg, rgba(24, 144, 255, 0.12)) !important;
		color: var(--menu-switch-primary, #1890ff) !important;
	}

	.menu-list-account-dropdown .ant-tree li span.ant-tree-switcher {
		height: 24px;
		line-height: 24px;
		width: 18px;
		cursor: pointer;
	}

	.menu-list-account-dropdown .ant-tree li ul {
		padding: 0 0 0 12px !important;
	}
</style>